<div class="search-container" [class.shift-right]="sidebarIsOpen">
    <div class="autocomplete-wrapper">
        <i class="pi pi-search search-icon"></i>
        <p-autoComplete 
            class="search-input"
            placeholder="{{ 'MAP.SEARCH.PLACEHOLDER' | translate }}"
            [(ngModel)]="search" 
            [suggestions]="filteredResults" 
            (completeMethod)="searchAddress($event)" 
            field="display_name"
            [forceSelection]="true"
            (onSelect)="selectResult($event)"
        >
            <ng-template let-item pTemplate="item">
            <div>
                {{ item.display_name }}
            </div>
            </ng-template>
        </p-autoComplete>
    </div>
</div>
